export const CONTACT = {
  owner: "Mamta Bhushan",
  phone: "+91 94154 05759",
  phoneRaw: "919415405759",
  city: "Ajnara Gen-X, Crossing Republik, Ghaziabad, Uttar Pradesh 201016",
  email: "hello@mamtaskitchen.in",
};

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/cc6355dc-e0b7-47c4-b7e9-c868823f1d39/images/330a077f69cd9ecc01069b611fcc36661e25db77503d776870b221ca79b41437.png";

export const FOUNDER_IMAGE =
  "https://images.pexels.com/photos/37330104/pexels-photo-37330104.jpeg";

export const PRODUCTS = [
  {
    id: "harimirch",
    name: "Hari Mirch ka Achar",
    english: "Green Chilli Pickle",
    price: 600,
    unit: "per kg",
    spice: "Hot",
    seasonal: false,
    tagline: "Fiery, bold, unapologetic.",
    description:
      "Plump green chillies slit and stuffed with mustard-fennel masala, steeped in cold-pressed mustard oil. Bright heat with a tangy finish.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cc6355dc-e0b7-47c4-b7e9-c868823f1d39/images/95c563ec84d6d12e206c3d2405ed9cd9ce9770c43c54d9823923ecea39affe6a.png",
  },
  {
    id: "mango",
    name: "Aam ka Achar",
    english: "Mango Pickle",
    price: 600,
    unit: "per kg",
    spice: "Hot",
    seasonal: false,
    tagline: "The one that started it all.",
    description:
      "Raw Himsagar mangoes, hand-cut and sun-cured in cold-pressed mustard oil with fenugreek, fennel and Kashmiri chilli.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cc6355dc-e0b7-47c4-b7e9-c868823f1d39/images/ef60eeeef63d997cff81ffae185f0926161d02810bdea2b311fde8e4e0d8407c.png",
  },
  {
    id: "lemon",
    name: "Nimbu ka Achar",
    english: "Lemon Pickle",
    price: 500,
    unit: "per kg",
    spice: "Medium",
    seasonal: false,
    tagline: "Soft, tangy, sun-mellowed.",
    description:
      "Whole lemons slow-softened in the sun with rock salt and warm spices until melt-in-mouth tender. A little sweet, a little sharp.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cc6355dc-e0b7-47c4-b7e9-c868823f1d39/images/fee6ba85fd9ced2b4902e7f9c61ea0575e3d749e85b10a9a982c7b879dc0e108.png",
  },
  {
    id: "mixed",
    name: "Mixed Vegetable Achar",
    english: "Mixed Pickle",
    price: 500,
    unit: "per kg",
    spice: "Hot",
    seasonal: false,
    tagline: "A little of everything good.",
    description:
      "Carrot, mango, lime, green chilli and cauliflower layered together in mustard oil — the loud, generous jar for the whole table.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cc6355dc-e0b7-47c4-b7e9-c868823f1d39/images/90acc4aee03b1d4f27d21fbb7220104760f2b3e63acb8f23e95a975e9d042082.png",
  },
  {
    id: "shalgam",
    name: "Shalgam ka Khatta Meetha Achar",
    english: "Sweet & Sour Turnip Pickle",
    price: 450,
    unit: "per kg",
    spice: "Mild-Sweet",
    seasonal: true,
    tagline: "The winter special.",
    description:
      "Purple turnips with jaggery, ginger and gud — a sweet-savoury North Indian winter heirloom made only in small seasonal batches.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cc6355dc-e0b7-47c4-b7e9-c868823f1d39/images/bb2a110b85172ff0ec3a83481b95d84d95525d21a245cae872823d824523f190.png",
  },
  {
    id: "singhada",
    name: "Singhada ka Achar",
    english: "Water Chestnut Pickle",
    price: 450,
    unit: "per kg",
    spice: "Mild",
    seasonal: true,
    tagline: "A rare winter treasure.",
    description:
      "Tender water chestnuts in spiced golden oil — a delicate, seasonal North Indian rarity you'll only find for a few weeks a year.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cc6355dc-e0b7-47c4-b7e9-c868823f1d39/images/5c7c8ee6f83ec786a5a4c2ae3570e2de43e75afa1532931170626585c9f817f7.png",
  },
];

export const MANIFESTO = [
  { n: "01", title: "Hand-cut, always", body: "Every mango, lemon and chilli is cut by hand in our kitchen — never by machine, never in a hurry." },
  { n: "02", title: "Sun-cured, never boiled", body: "We let the Indian sun do the work, curing each batch on the terrace the way grandmothers always did." },
  { n: "03", title: "Zero preservatives", body: "Only mustard oil, rock salt and whole spices. No colours, no chemicals, no shortcuts — ever." },
  { n: "04", title: "One family recipe", body: "The same masala Mamta wrote down twenty years ago, still measured by hand and by memory." },
];
